import { useCallback, useState } from "react";
import { useToast } from "../../../Hooks/toast";
import { downloadPixReceiptPdf } from "../../../Services/downloadPixReceiptPdf";

/**
 * Downloads PIX comprovante PDF.
 * Prefers QuestPDF `receipt_pdf_base64` (new model); falls back to IB receipt endpoints.
 * Legacy Azure HTML compiler is no longer used.
 */
export const useReceiptDownload = (receipt, { fileName = "comprovante-pix.pdf" } = {}) => {
  const [loadingDownload, setLoadingDownload] = useState(false);
  const { addToast } = useToast();

  const downloadPdf = useCallback(async () => {
    if (!receipt) return;

    setLoadingDownload(true);
    try {
      const result = await downloadPixReceiptPdf({
        receiptPdfBase64:
          receipt.receipt_pdf_base64 || receipt.receiptPdfBase64 || null,
        paymentId: receipt.pix_id || receipt.payment_id || receipt.paymentId,
        batchId: receipt.batch_id || receipt.batchId,
        fileName,
      });
      if (!result.success) {
        addToast({
          title: "Comprovante indisponível",
          description: result.message || "Tente novamente mais tarde.",
          type: "error",
        });
      }
    } catch {
      addToast({
        title: "Erro ao baixar comprovante!",
        description: "Ocorreu um erro na operação. Tente novamente mais tarde.",
        type: "error",
      });
    } finally {
      setLoadingDownload(false);
    }
  }, [receipt, fileName, addToast]);

  return { downloadPdf, loadingDownload };
};
